import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "org-map" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Node = _resolveComponent("Node")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.widget.children || [], (node, idx) => {
      return (_openBlock(), _createBlock(_component_Node, {
        key: `${node.name}-${idx}`,
        node: node
      }, null, 8 /* PROPS */, ["node"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}